import { combineReducers } from "@reduxjs/toolkit";

import type { FetchCoachmarksAction } from "entities/coachmarks/actionTypes";
import { CoachmarkEntityActionType } from "entities/coachmarks/actionTypes";
import type { CoachmarkEntityState } from "entities/coachmarks/types";
import { addUserOrLanguageChangeReset } from "entities/topics/reducerHelpers";

const initialState: CoachmarkEntityState = { byId: {} };

const byId = (state = initialState.byId, action: FetchCoachmarksAction): CoachmarkEntityState["byId"] => {
  switch (action.type) {
    case CoachmarkEntityActionType.FETCH_FULFILLED:
      return action.payload.coachmarks.reduce(
        (accumulator, next) => ({ ...accumulator, [next.id]: { ...state[next.id], ...next } }),
        state,
      );
    default:
      return state;
  }
};

export const coachmarksReducer = combineReducers({
  byId: addUserOrLanguageChangeReset(byId, initialState.byId),
});
